// Dynamic styles based on theme - to be used with useThemedStyles.
export const createDriverMyDayFocusCardStyles = (theme) => ({
	focusContent: {
		marginTop: 10,
	},
	focusInlineButton: {
		marginBottom: 8,
	},
	focusActionHint: {
		color: theme.text2,
		fontSize: 12,
		marginBottom: 10,
	},
	focusRow: {
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
		paddingVertical: 8,
		borderBottomWidth: 1,
		borderBottomColor: theme.border3,
	},
	focusRowText: {
		flex: 1,
		fontSize: 13,
		color: theme.text1,
		paddingRight: 8,
	},
	focusRowMeta: {
		fontSize: 12,
		color: theme.text2,
	},
	focusRowLabel: {
		marginBottom: 0,
	},
	accessStopName: {
		fontSize: 13,
		color: theme.text1,
	},
	ticketGroup: {
		paddingVertical: 8,
		borderBottomWidth: 1,
		borderBottomColor: theme.border3,
	},
	ticketGroupHeader: {
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
	},
	ticketDescription: {
		fontSize: 12,
		color: theme.text2,
		marginTop: 4,
	},
});
